__turbopack_context__.v({
  "cta": "oJ8iVG_cta",
  "icon": "oJ8iVG_icon",
  "inline": "oJ8iVG_inline",
  "placeholder": "oJ8iVG_placeholder",
  "plain": "oJ8iVG_plain",
  "slim": "oJ8iVG_slim",
  "text": "oJ8iVG_text",
  "thin": "oJ8iVG_thin",
});
